import { render, staticRenderFns } from "./BldComm.vue?vue&type=template&id=76204c1e&scoped=true&"
import script from "./BldComm.vue?vue&type=script&lang=js&"
export * from "./BldComm.vue?vue&type=script&lang=js&"
import style0 from "./BldComm.vue?vue&type=style&index=0&id=76204c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76204c1e",
  null
  
)

export default component.exports